import React, { Component } from "react";
import { CardColumns, CardDeck } from "reactstrap";

import Feature from "../../../../components/feature/Feature";
import "./RealsyncFeatures.scss";

const featureGroups = require("./RealsyncFeatures.json");

class RealsyncFeatures extends Component {
  render() {
    return (
      <div className="realsync-features-container">
        <CardDeck>
          {featureGroups.map((group) => {
            return group.features.map((feature) => {
              let featureFolder = feature.folder
                ? "./" + feature.folder + "/"
                : "./";
              let images = (feature.images || []).map((image) => {
                return { src: require(featureFolder + image) };
              });

              return (
                <Feature
                  key={feature.title}
                  title={feature.title}
                  description={feature.description}
                  thumbnail={images.length > 0 ? images[0].src : ""}
                  images={images}
                />
              );
            });
          })}
        </CardDeck>
      </div>
    );
  }
}

export default RealsyncFeatures;



// WEBPACK FOOTER //
// ./src/pages/products/realsync/features/RealsyncFeatures.jsx